import React from "react";

function PageNotFound() {
    return (
        <div
            style={{
                height: "90vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
            }}
        >
            <h3>Page not found</h3>
        </div>
    );
}

export default PageNotFound;
